<template>
  <td>
    <h6 class="custom-margin-h6-table">
      <strong>{{ $t('common_words.allotment_number_2') }}:</strong>
    </h6>
    <span v-for="(_, valueKey) in lots" :key="valueKey">
      <el-tag type="info" style="height: auto; width: 240px">
        <template
          v-if="
            Boolean(infoData.has_lot_code) &&
            infoData.code_lots &&
            infoData.code_lots[valueKey]
          "
        >
          {{ $t('common_words.code') }}: {{ infoData.code_lots[valueKey] }}<br />
        </template>
        {{ $t('common_words.name') }}: {{ infoData.name_lots[valueKey] }}<br />
        {{ $t('common_words.area') }}: {{ infoData.area_lots[valueKey] }}<br />
        {{ $t('common_words.variety') }}:
        {{ infoData.name_varieties[valueKey] }} <br />
        {{ $t('common_words.soil_type') }}:
        <span style="text-transform: capitalize">{{
          infoData.name_soils[valueKey]
            ? infoData.name_soils[valueKey]
            : $t('common_words.none')
        }}</span>
        <br />{{ $t('common_words.population') }}:
        {{
          infoData.population[valueKey]
            ? infoData.population[valueKey]
            : $t('common_words.none')
        }}
      </el-tag>
    </span>
  </td>
</template>
<script>
export default {
  name: 'td-info-lots',
  props: {
    lots: {
      required: true,
    },
    infoData: {
      type: Object,
      required: true,
    },
  },
};
</script>
